"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAGIC_WAGERING_COEFFICIENT = exports.SQUARE_POWER = exports.NOT_AVAILABLE_PLACEHOLDER = exports.DEFAULT_PRECISION = exports.HUNDRED_PERCENT = void 0;
exports.HUNDRED_PERCENT = 100;
exports.DEFAULT_PRECISION = 2;
exports.NOT_AVAILABLE_PLACEHOLDER = 'N/A';
exports.SQUARE_POWER = 2;
exports.MAGIC_WAGERING_COEFFICIENT = 5; // TODO: investigate what 5 means
